import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;
// const appName = process.env.REACT_APP_NAME;
if (!baseUrl) {
  console.warn("⚠️ Environment variables missing! Check your .env file.");
}

console.log("✅ Base URL:", baseUrl);
// console.log("✅ App Name:", appName);

const axiosInstance = axios.create({
  baseURL: `${baseUrl.replace(/\/$/, "")}`, // removes trailing slash
});
export default axiosInstance;
